import { Injectable } from '@angular/core';
import { LoadingController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class LoadingControllerWrapperService {

  loading: any;

  constructor(private loadingController: LoadingController) { }

  async presentLoading(message: string): Promise<void> {
    let loadingParameterObject = message ? { message: message } : null;
    this.loading = await this.loadingController.create(loadingParameterObject);

    return await this.loading.present();
  }

  async dismissLoading(): Promise<boolean> {
    if (!this.loading) return;
    return await this.loading.dismiss();
  }

}
